import axios from 'axios';
import Bowser from 'bowser';
import { capitalizeFirstLetter } from '~/utils/helpers';
import ENV from '../environment';

const browser = Bowser.getParser(window.navigator.userAgent);
const browserName = browser.getBrowserName();
const fullVersion = browser.getBrowserVersion();

const browserNameFinal = browserName
const browserVersion = fullVersion
const platformName = `${capitalizeFirstLetter(browser.getPlatformType())}, ${browser.getOS().name} ${browser.getOSVersion()}`

const api = axios.create({
  baseURL: ENV.API_URL,
  headers: {
    'Content-type': 'application/json'
  },
  data: {
    browserName: browserNameFinal,
    browserVersion: browserVersion,
    platformName: platformName
  }
});

api.interceptors.request.use(request => {
  const token = localStorage.getItem('token')

  request.data = {
    ...request.data,
    browserName: browserNameFinal,
    browserVersion: browserVersion,
    platformName: platformName
  }

  if (token) {
    request.headers.Authorization = `${token}`
  }
  return request
})

api.interceptors.response.use(null, error => {
  const loginUrl = '/login'
  if (error && error.status === 403) {
    localStorage.removeItem('token')
    window.location.href = loginUrl
    return
  }
  // handle errors from api with no response(body)
  if (error && (!error.response)) {
    error = {
      response: {
        data: {
          message: error.toString()
        }
      }
    }
    return Promise.reject(error)
  }

  else if ((error?.response?.data?.message === 'Token expired' ||
    error?.response?.data?.message === 'Invalid token') && window.location.href !== loginUrl) {
    localStorage.removeItem('token')
    window.location.href = loginUrl
    return
  }

  else {
    return Promise.reject(error)
  }

})

export default api
